import React, { useEffect, useState } from "react";
import "./Impressum.css";
import Header from "./Header";
import Footer from "./Footer";
import ScrollArrow from "./ScrollArrow";

export default function Impressum() {
  const [isPageLoaded, setIsPageLoaded] = useState(false);

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant", // Use instant for immediate scroll on page load
    });
  }, []);

  // Page load animation
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsPageLoaded(true);
    }, 150);

    return () => clearTimeout(timer);
  }, []);

  // Intersection Observer for scroll-based animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          } else {
            entry.target.classList.remove("visible");
          }
        });
      },
      {
        threshold: 0.08,
        rootMargin: "0px 0px -100px 0px",
      }
    );

    // Observe all sections
    const sections = document.querySelectorAll(".impressum-content > *");
    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Header />
      <div className={`impressum-page-wrapper ${isPageLoaded ? "loaded" : ""}`}>
        <div className="impressum-content">
          {/* Page Title */}
          <section className="impressum-section page-title">
            <div className="impressum-section-container">
              <h1 className="impressum-main-title">Impressum</h1>
              <p className="impressum-main-subtitle">
                Legal Information & Contact Details
              </p>
            </div>
          </section>

          {/* Contact Information */}
          <section className="impressum-section contact-info">
            <div className="impressum-section-container">
              <h2 className="section-eyebrow">Angaben gemäß § 5 TMG</h2>
              <div className="contact-details">
                <p>
                  <strong>Charles David Mupende</strong>
                </p>
                <p>Alleenstraße 15</p>
                <p>74372 Sersheim</p>
                <p>Deutschland</p>
              </div>
            </div>
          </section>

          {/* Contact Details */}
          <section className="impressum-section contact-details-section">
            <div className="impressum-section-container">
              <h2 className="section-eyebrow">Kontakt</h2>
              <div className="contact-grid">
                <div className="contact-item">
                  <span className="contact-label">Telefon:</span>
                  <span className="contact-value">+49 179 4157744</span>
                </div>
                <div className="contact-item">
                  <span className="contact-label">E-Mail:</span>
                  <span className="contact-value">
                    <a href="mailto:charlesdavid@mupende.com">
                      charlesdavid@mupende.com
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </section>

          {/* Disclaimer */}
          <section className="impressum-section disclaimer">
            <div className="impressum-section-container">
              <h2 className="section-eyebrow">Haftungsausschluss</h2>

              <h3>Haftung für Inhalte</h3>
              <p>
                Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt.
                Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte
                können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter
                sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen
                Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8
                bis 10 TMG sind wir als Diensteanbieter jedoch nicht
                verpflichtet, übermittelte oder gespeicherte fremde
                Informationen zu überwachen oder nach Umständen zu forschen, die
                auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur
                Entfernung oder Sperrung der Nutzung von Informationen nach den
                allgemeinen Gesetzen bleiben hiervon unberührt. Eine
                diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
                Kenntnis einer konkreten Rechtsverletzung möglich. Bei
                Bekanntwerden von entsprechenden Rechtsverletzungen werden wir
                diese Inhalte umgehend entfernen.
              </p>

              <h3>Haftung für Links</h3>
              <p>
                Unser Angebot enthält Links zu externen Webseiten Dritter, auf
                deren Inhalte wir keinen Einfluss haben. Deshalb können wir für
                diese fremden Inhalte auch keine Gewähr übernehmen. Für die
                Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
                oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten
                wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße
                überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der
                Verlinkung nicht erkennbar. Eine permanente inhaltliche
                Kontrolle der verlinkten Seiten ist jedoch ohne konkrete
                Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei
                Bekanntwerden von Rechtsverletzungen werden wir derartige Links
                umgehend entfernen.
              </p>

              <h3>Urheberrecht</h3>
              <p>
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
                diesen Seiten unterliegen dem deutschen Urheberrecht. Die
                Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
                Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
                schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                Downloads und Kopien dieser Seite sind nur für den privaten,
                nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf
                dieser Seite nicht vom Betreiber erstellt wurden, werden die
                Urheberrechte Dritter beachtet. Insbesondere werden Inhalte
                Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
                Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
                entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen
                werden wir derartige Inhalte umgehend entfernen.
              </p>
            </div>
          </section>
        </div>
      </div>
      <Footer />
      <ScrollArrow />
    </>
  );
}
